import { render, staticRenderFns } from "./customMobile.pug?vue&type=template&id=07017590&scoped=true&lang=pug&"
import script from "./customMobile.ts?vue&type=script&lang=ts&"
export * from "./customMobile.ts?vue&type=script&lang=ts&"
import style0 from "./customMobile.scss?vue&type=style&index=0&id=07017590&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07017590",
  null
  
)

export default component.exports